import { render, staticRenderFns } from "./CriarFollowUpModal.vue?vue&type=template&id=b355e65a&scoped=true"
import script from "./CriarFollowUpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarFollowUpModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarFollowUpModal.vue?vue&type=style&index=0&id=b355e65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b355e65a",
  null
  
)

export default component.exports